export const POSTING_CHANGE_TRACKING = {
  postLoadCreate: {
    source: 'posting.post_load.create',
    id: 18001,
  },
  postLoadUpdate: {
    source: 'posting.post_load.update',
    id: 18002,
  },
  postLoadDelete: {
    source: 'posting.post_load.delete',
    id: 18003,
  },
  postLoadForceDelete: {
    source: 'posting.post_load.force_delete',
    id: 18004,
  },
} as const;
